import {
  Component,
  inject,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { Bolseiro } from '../../../api/models';
import {
  BolseiroService,
  InstituicaoEnsinoService,
  CommunicationService,
  PaisService,
  ProvinciaService,
  MunicipioService,
  UtilizadorService,
} from '../../../api/services';
import { ApiService } from '@core/providers/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {
  TableComponent,
  TableColumn,
} from '@app/shared/components/table/table.component';
import { Pagination } from '@app/shared/model';
import { CadastrarBolseirosComponent } from '../../../bolseiros/cadastrar-bolseiros/cadastrar-bolseiros.component';
import { FilterItem } from '../../../api/models';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputText } from 'primeng/inputtext';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-instituicoes-ensino-listar-bolseiros',
  imports: [
    CommonModule,
    DialogModule,
    InputText,
    Button,
    SelectModule,
    FormsModule,
    ReactiveFormsModule,
    SearchBarComponent,
    ToastModule,
    ConfirmDialogModule,
    TableComponent,
    DataVoidComponent,
  ],
  providers: [
    DialogService,
    ApiService,
    BolseiroService,
    InstituicaoEnsinoService,
    MessageService,
    ConfirmationService,
    CommunicationService,
    UtilizadorService,
  ],
  templateUrl: './instituicoes-ensino-listar-bolseiros.component.html',
  styleUrls: ['./instituicoes-ensino-listar-bolseiros.component.scss'],
  standalone: true,
})
export class InstituicoesEnsinoListarBolseirosComponent
  implements OnInit, OnDestroy {
  dialogService = inject(DialogService);
  private router = inject(Router);
  confirmationService = inject(ConfirmationService);
  messageService = inject(MessageService);
  bolseiroService = inject(BolseiroService);
  instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  communicationService = inject(CommunicationService);
  paisService = inject(PaisService);
  provinciaService = inject(ProvinciaService);
  municipioService = inject(MunicipioService);
  utilizadorService = inject(UtilizadorService);
  route = inject(ActivatedRoute);
  isLoading: boolean = false;
  form!: FormGroup;
  constructor(private fb: FormBuilder) { }
  bolseiros: Bolseiro[] = [];
  private subscriptions = new Subscription();
  pagination: Pagination<Bolseiro> = new Pagination<Bolseiro>();
  estados = [
    { id: 'ativo', designacao: 'Activo' },
    { id: 'inativo', designacao: 'Inactivo' },
  ];
  tiposDeBolsa = [
    { id: 'parcial', designacao: 'Parcial' },
    { id: 'integral', designacao: 'Integral' },
  ];
  nacionalidades = [
    { label: 'Angola', id: 1 },
    { label: 'Namibiana', id: 2 },
  ];

  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'nome',
      placeholder: 'Pesquise por nome',
    },
    {
      type: 'text',
      controlName: 'NumeroBI',
      placeholder: 'Pesquise por BI',
    },
  ];

  estadoCivilOptions = [
    { label: 'Solteiro', id: 1 },
    { label: 'Casado', id: 2 },
  ];

  generoOptions = [
    { label: 'Masculino', id: 1 },
    { label: 'Feminino', id: 2 },
  ];

  nivelAcademicoOptions = [
    { label: 'Base', id: 1 },
    { label: 'Médio', id: 2 },
    { label: 'Licenciado', id: 3 },
  ];
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  utilizadores: any[] = [];
  @Output() bolseiroCount: EventEmitter<number> = new EventEmitter<number>();
  actionOptions: MenuItem[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      command: (event) => this.editBolseiro(event.item?.['data']),
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      command: (event) => this.deleteBolseiro(event.item?.['data']),
    },
  ];
  columns: TableColumn[] = [
    { field: 'nome', header: 'Nome' },
    { field: 'generoDescricao', header: 'Gênero' },
    { field: 'nivelAcademicoDescricao', header: 'Nível Académico' },
    { field: 'contactoPrincipal', header: 'Contato Principal' },
    { field: 'email', header: 'Email' }
  ];

  getAllUtilizadores() {
    this.isLoading = true; // Iniciar carregamento
    this.utilizadorService.list().subscribe(
      (data) => {
        this.utilizadores = data;
        this.isLoading = false; // Parar carregamento
      },
      (error) => {
        console.error('Erro ao buscar utilizadores:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar utilizadores.',
        });
        this.isLoading = false; // Parar carregamento
      }
    );
  }

  ngOnInit() {
    this.getAllUtilizadores();
    this.loadBolseirosByInstituicaoEnsino(this.instituicaoEnsinoID);
    this.subscriptions.add(
      this.communicationService.countryChanged$.subscribe(
        (country: string | null) => {
          if (country) {
            this.loadProvinces(country);
          }
        }
      )
    );

    this.subscriptions.add(
      this.communicationService.provinceChanged$.subscribe(
        (province: string | null) => {
          if (province) {
            this.loadMunicipalities(province);
          }
        }
      )
    );
  }

  get instituicaoEnsinoID(): number {
    return Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadBolseirosByInstituicaoEnsino(
    instituicaoEnsinoID: number,
    queryParams?: any
  ) {
    this.subscriptions.add(
      this.bolseiroService
        .list({ ...queryParams, InstituicaoEnsinoID: instituicaoEnsinoID })
        .subscribe((response: { data: Bolseiro[]; totalRecords: number }) => {
          this.pagination.data = response.data;
          this.pagination.totalRecords = response.totalRecords;
          this.bolseiroCount.emit(this.pagination.data.length);
        })
    );
  }

  onActionSelected(event: { event: any; rowData: Bolseiro }) {
    const action = event.event.value;
    const bolseiro = event.rowData;
    if (action === 'edit') {
      this.editBolseiro(bolseiro);
    } else if (action === 'delete') {
      this.deleteBolseiro(bolseiro);
    }
  }

  editBolseiro(bolseiro: Bolseiro) {
    this.router.navigate(['gestao-bolseiros/bolseiros/cadastrar-bolseiro'], {
      queryParams: {
        bolseiroId: bolseiro.id,
      },
    });
  }

  loadCountries() {
    this.paisService.list().subscribe((countries) => {
      this.countries = countries;
    });
  }

  loadProvinces(country: string) {
    this.provinciaService.list(country).subscribe((provinces) => {
      this.provinces = provinces;
      this.communicationService.updateProvinces(provinces);
      this.municipalities = []; // Reset municipalities when country changes
    });
  }

  loadMunicipalities(province: string) {
    this.municipioService.list(province).subscribe((municipalities) => {
      this.municipalities = municipalities;
      this.communicationService.updateMunicipalities(municipalities);
    });
  }

  deleteBolseiro(bolseiro: Bolseiro) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja eliminar este bolseiro?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Cancelar',
      acceptIcon: 'pi pi-trash',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.bolseiroService.delete(bolseiro.id).subscribe(
          (response: any) => {
            this.loadBolseirosByInstituicaoEnsino(this.instituicaoEnsinoID);
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Bolseiro eliminado com sucesso!',
            });
          },
          (error: any) => {
            console.error('Erro ao eliminar bolseiro:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao eliminar bolseiro.',
            });
          }
        );
      },
    });
  }

  showDialog() {
    const instituicaoEnsinoID = this.instituicaoEnsinoID;
    const ref = this.dialogService.open(CadastrarBolseirosComponent, {
      showHeader: false,
      width: '50%',
      modal: true,
      data: {
        utilizadores: this.utilizadores,
        nacionalidades: this.nacionalidades,
        estadoCivilOptions: this.estadoCivilOptions,
        generoOptions: this.generoOptions,
        nivelAcademicoOptions: this.nivelAcademicoOptions,
        provincias: this.provinces,
        municipios: this.municipalities,
        tiposDeBolsa: this.tiposDeBolsa,
        estados: this.estados,
        bolseiros: this.bolseiros,
        provinces: this.provinces,
        municipalities: this.municipalities,
        countries: this.countries,
      },
    });

    ref.onClose.subscribe((data) => {
      if (data) {
        this.isLoading = true; // Iniciar carregamento
        this.bolseiroService.store(data).subscribe(
          (response: any) => {
            this.loadBolseirosByInstituicaoEnsino(instituicaoEnsinoID);
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Bolseiro adicionado com sucesso!',
            });

            this.isLoading = false; // Parar carregamento
          },
          (error: any) => {
            console.error('Erro ao adicionar bolseiro:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao adicionar bolseiro.',
            });
            this.isLoading = false; // Parar carregamento
          }
        );
      }
    });
  }

  onPageChange(event: { first: number; rows: number }) {
    this.pagination.pageNumber = event.first / event.rows + 1;
    this.pagination.pageSize = event.rows;
    this.loadBolseirosByInstituicaoEnsino(this.instituicaoEnsinoID);
  }

  trackById(index: number, item: any) {
    return item.id;
  }

  showFilter = false;

  showFilterModal() {
    this.showFilter = true;
  }

  onFormValueChange(queryParams: any) {
    this.loadBolseirosByInstituicaoEnsino(
      this.instituicaoEnsinoID,
      queryParams
    );
    this.showFilter = false;
  }

}
